module.exports = __webpack_public_path__ + "img/white-text.864898a5.jpg";